import React from 'react';

const generateMetaTags = tagsArray => tagsArray.map(metaProps => <meta {...metaProps} />);
export default generateMetaTags;
